import { MobileCard } from '@/Components/shared/List/MobileCard';
import type { InvoiceListItem } from '../types/invoice.types';
import { getInvoiceStateLabel, getInvoiceStateColorClass } from '../utils/invoiceStateLabels';
import { getInvoiceKindLabel } from '../utils/invoiceKindLabels';

function formatDate(dateStr: string | null): string {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
}

interface InvoiceMobileCardsProps {
  data: InvoiceListItem[];
  onRowClick?: (invoice: InvoiceListItem) => void;
}

export function InvoiceMobileCards({ data, onRowClick }: InvoiceMobileCardsProps) {
  return (
    <div className="tw-space-y-3">
      {data.map((invoice) => (
        <MobileCard
          key={invoice.id}
          title={invoice.label || '-'}
          subtitle={invoice.companyName}
          status={
            <span className={`tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-rounded ${getInvoiceStateColorClass(invoice.state)}`}>
              {getInvoiceStateLabel(invoice.state)}
            </span>
          }
          fields={[
            { label: 'Type', value: getInvoiceKindLabel(invoice.invoiceKind, 'Contrats & Services') },
            { label: 'Montant HT', value: <span className="tw-font-medium">{formatCurrency(invoice.amount - (invoice.taxAmount || 0))}</span> },
            { label: 'Période', value: invoice.startDate && invoice.endDate ? `${formatDate(invoice.startDate)} - ${formatDate(invoice.endDate)}` : '-' },
            { label: 'Date', value: formatDate(invoice.createdAt) },
          ]}
          onClick={onRowClick ? () => onRowClick(invoice) : undefined}
        />
      ))}
    </div>
  );
}
